import { render, staticRenderFns } from "./ProductBatchTransferTable.vue?vue&type=template&id=1a7aff7e&"
import script from "./ProductBatchTransferTable.vue?vue&type=script&lang=js&"
export * from "./ProductBatchTransferTable.vue?vue&type=script&lang=js&"
import style0 from "./ProductBatchTransferTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports